import { repository } from '@petrhythm/data';
import { buildRecordHistory, type HistoryInput } from '@petrhythm/core';

export const HISTORY_TABLES: Array<keyof HistoryInput> = ['events', 'vitals', 'treatments', 'treatmentLogs', 'meals', 'coughLogs', 'gaitLogs', 'checkins', 'qolRecords', 'visits', 'labs', 'costs', 'routines', 'routineLogs', 'carePlans', 'careQuestions', 'careEpisodes', 'eliminations', 'waterLogs', 'photoDays', 'dayMarks'];
export async function readRecordHistory(petId: string) {
  const entries = await Promise.all(HISTORY_TABLES.map(async table => [table, await repository.list(table)] as const));
  return buildRecordHistory(petId, Object.fromEntries(entries) as unknown as HistoryInput);
}
